module.exports = __webpack_public_path__ + "img/loader.86d4ede2.gif";